import {Link} from "react-router-dom";
import {useCallback} from "react";
import {useTranslation} from "react-i18next";


interface ContentProps {
    className?: string;
}

function LangChanger({className}: ContentProps) {
    const {i18n} = useTranslation();

    const switchLanguage = useCallback(async (lang: string) => {
        document.documentElement.lang = lang;
        await i18n.changeLanguage(lang);
    }, [i18n]);

    return (
        <ul className={className ?? "ms-auto d-flex list-unstyled mb-3 language-changer"}>
            <li className="nav-item">
                <Link
                    className={`nav-link px-2 ${i18n.language.startsWith("ko") ? "on" : ""}`}
                    to="#"
                    onClick={() => switchLanguage("ko")}
                >KR</Link>
            </li>
            <li className="nav-item">
                <Link
                    className={`nav-link px-2 ${i18n.language.startsWith("en") ? "on" : ""}`}
                    to="#"
                    onClick={() => switchLanguage("en")}
                >EN</Link>
            </li>
        </ul>
    );
}


export default LangChanger;